import { QueryResult, useQuery } from '@apollo/client'
import { USER_MANAGER_ROLES_BY_COMPANY, USER_MANAGER_ROLES_BY_EMPLOYEE } from '../Queries'
import {
  FindUserManagerRolesByCompanyQueryVariables,
  FindUserManagerRolesByCompanyQuery,
  FindUserManagerRolesByEmployeeQueryVariables,
  FindUserManagerRolesByEmployeeQuery,
} from '../../../types'

export const useUserManagersRolesByCompany = (
  companyId: string,
): QueryResult<FindUserManagerRolesByCompanyQuery, FindUserManagerRolesByCompanyQueryVariables> => {
  return useQuery<FindUserManagerRolesByCompanyQuery, FindUserManagerRolesByCompanyQueryVariables>(USER_MANAGER_ROLES_BY_COMPANY, {
    variables: { companyId },
    fetchPolicy: 'network-only',
  })
}

export const useUserManagersRolesByEmployee = (
  employeeId: string,
): QueryResult<FindUserManagerRolesByEmployeeQuery, FindUserManagerRolesByEmployeeQueryVariables> => {
  return useQuery<FindUserManagerRolesByEmployeeQuery, FindUserManagerRolesByEmployeeQueryVariables>(USER_MANAGER_ROLES_BY_EMPLOYEE, {
    variables: { employeeId },
    fetchPolicy: 'network-only',
  })
}
